export const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
export const clear = score => score >= 80

function zeroPadding(original) {
    return ("0" + original).slice(-2)
}

export const floatToMinutes = fSeconds => {
    const sec = Math.floor(fSeconds) % 60
    const min = Math.floor(fSeconds / 60)
    return min + ":" + zeroPadding(sec)
}

export const secondToMinutes = seconds => {
    const sec = Math.floor(seconds) % 60
    const min = Math.floor(seconds / 60)
    return min + ":" + zeroPadding(sec)
}
